module.exports = __webpack_public_path__ + "img/Presencia-Minas-Barras.25fa4689.png";